import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const passwordResetService = {
  requestReset: async (email) => {
    const response = await api.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
    return response.data;
  },

  validateToken: async (token) => {
    const response = await api.post(API_ENDPOINTS.AUTH.VALIDATE_RESET_TOKEN, { token });
    return response.data;
  },

  resetPassword: async (token, new_password, confirm_password) => {
    const response = await api.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, {
      token,
      new_password,
      confirm_password,
    });
    return response.data;
  },
};

export default passwordResetService;